( function () {
  if ( window.__bergMarketoMultiInstanceInit ) {
    return;
  }

  if ( typeof feWp === 'undefined' || typeof wp === 'undefined' ) {
    return;
  }

  window.__bergMarketoMultiInstanceInit = true;

  const { hooks: { addFilter: addFilterFe, applyFilters } } = feWp;
  const { hooks: { doAction } } = wp;
  const MKTOFORM_ID_PREFIX = 'mktoForm_';
  const FOOTER_HOST_SELECTOR = '[data-berg-marketo-footer-form]';

  function getWrappers( config ) {
    const wrapperId = config.blockWrapperId;
    const wrappers = [];

    if ( wrapperId ) {
      document.querySelectorAll( `[id="${CSS.escape( wrapperId )}"]` ).forEach( function ( wrapper ) {
        wrappers.push( wrapper );
      } );
    }

    if ( !wrappers.length && config.embeddedFormId ) {
      document.querySelectorAll( `.e-emf-${config.embeddedFormId}` ).forEach( function ( wrapper ) {
        wrappers.push( wrapper );
      } );
    }

    return wrappers;
  }

  function getFormPlaceholderForWrapper( wrapper ) {
    if ( !wrapper ) return null;

    const parent = wrapper.parentElement;
    if ( !parent ) return null;

    const siblingForm = wrapper.previousElementSibling;
    if ( siblingForm?.tagName === 'FORM' ) {
      return siblingForm;
    }

    return parent.querySelector( ':scope > form' );
  }

  function clearMarketoFormIds( formId ) {
    const targetId = `${MKTOFORM_ID_PREFIX}${formId}`;

    document.querySelectorAll( 'form' ).forEach( function ( formEl ) {
      if ( formEl.id === targetId ) {
        formEl.removeAttribute( 'id' );
      }
    } );
  }

  function prepareFormElement( formEl, formId, config ) {
    clearMarketoFormIds( formId );
    formEl.setAttribute( 'data-formId', formId );
    formEl.setAttribute( 'data-embedded-form-id', config.embeddedFormId );
    formEl.classList.add( 'mktoForm' );
    formEl.id = `${MKTOFORM_ID_PREFIX}${formId}`;
  }

  function hasVisibleFooterFormSection() {
    const popup = document.getElementById( 'download-now' );

    return Array.from( document.querySelectorAll( '.e-stn--cta-with-form' ) ).some( function ( section ) {
      return !popup?.contains( section );
    } );
  }

  function ensureFooterFormHost() {
    if ( hasVisibleFooterFormSection() ) {
      return null;
    }

    let footerHost = document.querySelector( FOOTER_HOST_SELECTOR );
    if ( footerHost ) {
      return footerHost;
    }

    const popup = document.getElementById( 'download-now' );
    const popupSection = popup?.querySelector( '.e-stn--cta-with-form' );
    if ( !popupSection || !popup?.parentNode ) {
      return null;
    }

    footerHost = popupSection.cloneNode( true );
    footerHost.setAttribute( 'data-berg-marketo-footer-form', 'true' );
    footerHost.querySelectorAll( 'form, .e-emf, script[src*="forms2"]' ).forEach( function ( node ) {
      node.remove();
    } );

    popup.parentNode.insertBefore( footerHost, popup );
    return footerHost;
  }

  function ensureFormPlaceholder( config, targetWrapper ) {
    let wrapper = targetWrapper || getWrappers( config )[0] || null;
    let formEl = getFormPlaceholderForWrapper( wrapper );

    if ( wrapper && formEl ) {
      return { wrapper: wrapper, formEl: formEl };
    }

    const footerHost = ensureFooterFormHost();
    if ( !footerHost ) {
      return null;
    }

    const formContainer = footerHost.querySelector( '.e-col--right-column .e-div' )
      || footerHost.querySelector( '.e-div' );
    if ( !formContainer ) {
      return null;
    }

    formEl = document.createElement( 'form' );
    formEl.setAttribute( 'onsubmit', '_6si.send(event);' );

    wrapper = document.createElement( 'div' );
    wrapper.className = `e-emf e-emf--dlt e-emf-${config.embeddedFormId}`;
    wrapper.id = config.blockWrapperId;

    formContainer.appendChild( formEl );
    formContainer.appendChild( wrapper );

    return { wrapper: wrapper, formEl: formEl };
  }

  function handleFormAction( config ) {
    const {
      responseType,
      redirectURL,
      downloadFileURL,
      linkOpenType,
      cookieValidity,
      popupVideo,
      popupVideoURL,
      popupVideoUploadURL,
      customVideoScript,
      defaultClass,
      embeddedFormId,
      currentPostId,
      isParentBlockGatedContentBlock,
      downloadButtonLabel,
    } = config;

    if ( responseType === 'redirect' && redirectURL ) {
      window.open( redirectURL, linkOpenType );
    } else if ( responseType === 'download' && downloadFileURL ) {
      window.open( downloadFileURL, '_blank' );
    } else if ( responseType === 'redirectDownload' && redirectURL && downloadFileURL ) {
      window.open( downloadFileURL, '_blank' );
      window.open( redirectURL, linkOpenType );
    } else if ( responseType === 'resource-same-page' ) {
      if ( isParentBlockGatedContentBlock ) {
        const expires = new Date();
        expires.setTime( expires.getTime() + ( 24 * cookieValidity * 60 * 60 * 1000 ) );
        document.cookie = `postId_${currentPostId}=true; expires=${expires.toUTCString()}; path=/`;
      }
      setTimeout( function () {
        window.location.reload( true );
      }, 1000 );
    } else if ( responseType === 'popup' ) {
      if (
        ( popupVideo === 'url' && popupVideoURL )
        || ( popupVideo === 'upload' && popupVideoUploadURL )
        || ( popupVideo === 'embedded' && customVideoScript )
      ) {
        document.getElementById( `${defaultClass}_fancybox_${embeddedFormId}` )?.click();
      }
    } else if ( responseType === 'thankYouDownloadCta' ) {
      const cookieName = `hs_form_${currentPostId}`;
      const expires = new Date();
      expires.setTime( expires.getTime() + 600000 );
      document.cookie = `${cookieName}=true;expires=${expires.toUTCString()}; path=/`;
      const label = downloadButtonLabel?.trim() || '';
      window.open(
        `${redirectURL}?file=${btoa( downloadFileURL )}&postId=${btoa( currentPostId )}&label=${encodeURIComponent( label )}`,
        '_self'
      );
    }
  }

  function handleFormResponse( config ) {
    const { responseMessage, embeddedFormId, formId } = config;
    const formEl = document.querySelector( `[data-embedded-form-id="${embeddedFormId}"]` )
      || document.getElementById( `${MKTOFORM_ID_PREFIX}${formId}` );

    if ( responseMessage && formEl ) {
      formEl.innerHTML = responseMessage;
    }

    handleFormAction( config );
  }

  function stashMarketoLeadValues( values ) {
    if ( ! values || typeof values !== 'object' ) {
      return;
    }

    try {
      window.sessionStorage.setItem( 'ironclad_mkto_lead', JSON.stringify( values ) );
    } catch ( e ) {
      // Ignore storage failures; ChiliPiper thank-you handoff is best-effort.
    }
  }

  function attachSuccessHandler( form, config ) {
    form.onSuccess( function ( values, followUpUrl ) {
      stashMarketoLeadValues( values );
      doAction( 'b3rg_embedded_form_marketo_form_load_event', config, form, followUpUrl );

      const hasFollowUp = typeof followUpUrl === 'string' && followUpUrl.trim() !== '';

      if ( config.responseType === 'original' && hasFollowUp ) {
        window.location.href = followUpUrl;
      } else {
        const handler = applyFilters(
          'b3rg_embedded_form_marketo_form_load_handler',
          handleFormResponse,
          config
        );
        handler( config );
      }

      return false;
    } );
  }

  function expandConfigInstances( configs ) {
    const instances = [];
    const seenWrappers = new WeakSet();
    const seenOrphans = new Set();

    configs.forEach( function ( config ) {
      const wrappers = getWrappers( config );

      if ( wrappers.length ) {
        wrappers.forEach( function ( wrapper ) {
          if ( seenWrappers.has( wrapper ) ) {
            return;
          }

          seenWrappers.add( wrapper );
          instances.push( {
            config: config,
            targetWrapper: wrapper,
          } );
        } );
        return;
      }

      const orphanKey = config.embeddedFormId || config.formId;
      if ( seenOrphans.has( orphanKey ) ) {
        return;
      }

      seenOrphans.add( orphanKey );
      instances.push( {
        config: config,
        targetWrapper: null,
      } );
    } );

    return instances;
  }

  function loadFormInstances( instances ) {
    const formId = instances[0].config.formId;
    const { marketoBaseUrl, munchkinId } = instances[0].config;
    const placeholders = instances
      .map( function ( instance ) {
        const placeholder = ensureFormPlaceholder(
          instance.config,
          instance.targetWrapper
        );
        if ( !placeholder ) {
          return null;
        }

        return {
          config: instance.config,
          formEl: placeholder.formEl,
        };
      } )
      .filter( Boolean );

    if ( !placeholders.length ) {
      return;
    }

    const IP_API_URL = 'https://ipapi.co/json/?key=c5CTtYsq6TOebWvtSFkb0nsoNPUnkTMjQdUKwK3Az3m9FXHXg9';

    function getVisitorCountry() {
      if ( typeof window.__ironcladGetVisitorCountry === 'function' ) {
        return window.__ironcladGetVisitorCountry();
      }
      if ( !window.__ironcladVisitorCountryPromise ) {
        window.__ironcladVisitorCountryPromise = fetch( IP_API_URL )
          .then( function ( response ) {
            if ( !response.ok ) {
              throw new Error( 'IP API returned ' + response.status );
            }
            return response.json();
          } )
          .then( function ( data ) {
            return data.country || '';
          } )
          .catch( function ( error ) {
            console.error( 'Error fetching geolocation from ipapi:', error );
            return '';
          } );
      }
      return window.__ironcladVisitorCountryPromise;
    }

    function applyIpinfoCountryToForm( form, country ) {
      if ( typeof window.__ironcladApplyIpinfoCountryToForm === 'function' ) {
        window.__ironcladApplyIpinfoCountryToForm( form, country );
        return;
      }
      if ( form && country && typeof form.setValues === 'function' ) {
        form.setValues( { ipinfoCountry: country } );
      }
    }

    function startLoading() {
      if ( typeof window.MktoForms2 === 'undefined' ) {
        return;
      }

      // Match demo-sidepop: set country in loadForm callback so Email_Opt_In__c
      // visibility does not paint open for US and then fail to re-hide.
      getVisitorCountry().then( function ( country ) {
        ( function loadNext( index ) {
          const instance = placeholders[index];
          if ( !instance ) return;

          const config = instance.config;
          const formEl = instance.formEl;
          prepareFormElement( formEl, formId, config );

          window.MktoForms2.loadForm( marketoBaseUrl, munchkinId, formId, function ( form ) {
            applyIpinfoCountryToForm( form, country );
            attachSuccessHandler( form, config );
            formEl.removeAttribute( 'id' );
            loadNext( index + 1 );
          } );
        } )( 0 );
      } );
    }

    if ( typeof window.MktoForms2 !== 'undefined' ) {
      startLoading();
      return;
    }

    let tries = 0;
    const waitForMarketo = window.setInterval( function () {
      tries += 1;
      if ( typeof window.MktoForms2 !== 'undefined' || tries > 200 ) {
        window.clearInterval( waitForMarketo );
        startLoading();
      }
    }, 25 );
  }

  function initMultiInstanceForms( configs ) {
    const formIds = configs.map( function ( config ) {
      return config.formId;
    } );
    formIds.forEach( clearMarketoFormIds );

    const instances = expandConfigInstances( configs );
    const instancesByFormId = instances.reduce( function ( groups, instance ) {
      if ( !groups[instance.config.formId] ) {
        groups[instance.config.formId] = [];
      }
      groups[instance.config.formId].push( instance );
      return groups;
    }, {} );

    Object.values( instancesByFormId ).forEach( loadFormInstances );
  }

  addFilterFe(
    'b3rg_embedded_form_marketo_event_binder',
    'b3rg/embedded-forms',
    function () {
      const pendingConfigs = [];
      let scheduled = false;

      return function ( config ) {
        pendingConfigs.push( config );

        if ( scheduled ) return;
        scheduled = true;

        queueMicrotask( function () {
          scheduled = false;
          initMultiInstanceForms( pendingConfigs.splice( 0 ) );
        } );
      };
    }
  );
}() );
